var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.824,
    height: 14.588,
    viewBox: "0 0 15.824 14.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M15.206,21.241H12.162v-.623a.618.618,0,1,0-1.236,0v.623H4.9v-.623a.618.618,0,1,0-1.236,0v.623H.618A.618.618,0,0,0,0,21.859V33.97a.618.618,0,0,0,.618.618H15.206a.618.618,0,0,0,.618-.618V21.859A.618.618,0,0,0,15.206,21.241Zm-.618,12.11H1.236V22.478H3.662V23.1a.618.618,0,1,0,1.236,0v-.623h6.027V23.1a.618.618,0,0,0,1.236,0v-.623h2.426Z",
    transform: "translate(0 -20)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(7.078 5.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(7.078 9.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(3.446 5.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(10.709 5.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(3.446 9.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821",
    transform: "translate(10.709 9.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 0.834,
    cy: 0.834,
    r: 0.834,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.3ee3cad6516c79991ccb595eb4ea4ca9.svg";
export { ForwardRef as ReactComponent };